export const threeDigitsNumber = number => "000".concat(number).substr(-3);

export const fourthPositions = (width) => {
  const fourthWidth = width / 4;

  return [
    fourthWidth / 2,
    fourthWidth * 2 - fourthWidth / 2,
    fourthWidth * 3 - fourthWidth / 2,
    fourthWidth * 4 - fourthWidth / 2,
  ]
};

export function fadeOutSound(sound, duration) {
  this.tweens.add({
    targets: sound,
    volume: 0,
    duration,
  });
};
